var React = require('react');

function IconExit (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"icon - exit - 24px"},[React.createElement("path",{"style":{"fill":"none"},"d":"M0 0h16v16H0z","key":0}),React.createElement("path",{"data-name":"↳color","d":"m7.86 6.68 5.253-5.253A.835.835 0 0 0 11.931.246L6.679 5.5 1.426.246A.835.835 0 0 0 .245 1.427L5.5 6.68.245 11.933a.835.835 0 1 0 1.181 1.181l5.253-5.253 5.253 5.253a.835.835 0 0 0 1.181-1.181z","transform":"translate(1.19 1.452)","style":{"fill":"#031425"},"key":1})]));
}

IconExit.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = IconExit;

IconExit.default = IconExit;
